module.exports = __webpack_public_path__ + "communication-settings-icon.svg?b68f07ab03f7dba5d34c9846f5c66f3a";